import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import {
    Paper,
    FormControl,
    TextField,
    Select,
    MenuItem,
    Typography,
    FormGroup,
} from '@material-ui/core';
import axios from 'axios';
import Common from '../../Common';
import SearchButton from './SupponetUserSearchButton';
import ResetButton from './SupponetUserResetButton';

const styles = (theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '95%',
        marginTop: '5px',
        justifyContent: 'center',
    },
    grid: {
        // border: `1px solid ${theme.palette.divider}`,
        margin: '0px auto',
        marginTop: '10px',
        border: '1px solid rgba(0, 0, 0, 0.5);',
        borderRadius: '5px',
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.secondary,
    },
    formControll: {
        margin: '0px 7px',
    },
    dateSelect: {
        margin: '0px 7px 0px 55px',
    },
    controllLabel: {
        margin: '20px 0px 10px 20px',
    },
    fieldHover: {
        width: '375px',
        cursor: 'pointer',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#f5f5f5',
        },
    },
    conditionLeft: {
        width: '300px',
    },
    conditionRight: {
        width: '350px',
    },
    select: {
        margin: theme.spacing(1),
        width: '300px',
    },
    title:{
        marginTop: '30px'
    },
    johokubunList:{
        borderBottom: 'solid 1px #E0E0E0',
    },
    inputKeyword:{
        margin: '20px 0px 10px 30px',
    },
    selectKubunArea: {
        marginLeft: '50px',
        alignItems: 'center',
    },
    categorySelect:{
        margin: '15px 7px 0px 22px',
    },
    shubetsuSelect:{
        margin: '0px 7px 0px 22px',
    },
    memo:{
        margin: '0px 7px 0px 55px',
    },
    endFlg:{
        width:'100px'
    },
    deletionFlgList:{
        borderBottom: 'solid 2px #FFF',
        height:'40px',
    },
});

const publishFlg = ['未了','完了','デマ'];

const SettingUserSearch = withCookies((props) => {
    const { classes, setData, cookies, setAllUpdate, setIsLoading} = props;
    const [recordId, setRecordId] = React.useState('');
    const [creationDate, setCreationDate] = React.useState('');
    const [reportDate, setReportDate] = React.useState('');
    const [supponetData, setSupponetData] = React.useState([]);
    const [categoryList, setCategoryList] = React.useState([]);
    const [displayCategory, setDisplayCategory] = React.useState('');
    const [displayShubetsu, setDisplayShubetsu] = React.useState('');
    const [selectCategory, setSelectCategory] = React.useState([]);
    const [shubetsuList, setShubetsuList] = React.useState([]);
    const [selectShubetsu, setSelectShubetsu] = React.useState([]);
    const [memo, setMemo] = React.useState('');
    const [address, setAddress] = React.useState('');
    const [endFlg, setEndFlg] = React.useState([]);

    //-----------------------------------------------------------------
    //              ページに格納するデータの取得
    //-----------------------------------------------------------------
    function getCategoryData() {
        if(categoryList.length === 0){
            //TOKEN取得
            axios
                .post(`${Common.apiServerUrl()}/api/auth/token`, {
                    headers: {
                        Authorization: 'Bearer ' + cookies.get('id_token'),
                    },
                    data: {},
                })
                .then(Common.handleErrors)
                .then((Response) => {
                    if (Response.success) {
                        cookies.set('token', Response.token, {
                            maxAge: 60 * 60 * 24 * 30, //30日間
                            httpOnly: false,
                            path: '/',
                            secure: true,
                        });

                        const jichitaiToken = cookies.get('x-jichitai-token');
                        const jichitaiId = cookies.get('x-jichitai-jichitaiid');

                        const header = {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'x-suppportcenter-token': Response.token,
                            'x-jichitai-jichitaiid': jichitaiId,
                            'x-jichitai-token': jichitaiToken,
                        };

                        //-------------------------------------------
                        //プルダウンに表示する情報区分の取得 APIアクセス先(johoKubun.js)
                        //cookieに保存している職員番号でGetアクセスを行う
                        //-------------------------------------------
                        // -------------------------axios------------------------------
                        axios
                            .get(`${Common.apiServerUrl()}/api/supponet`, {
                                headers: header,
                                data: {},
                            })
                            .then(Common.handleErrors)
                            .then((response) => {
                                const res = response.result;
                                if (response.success) {
                                    if (res.category.length === 0 || res.shubetsu.length === 0) {
                                        return;
                                    } else {
                                        setSupponetData(res);
                                        setCategoryList(res.category);
                                    }
                                } else {
                                    window.alert(`code : [${response.type}]\nmessage : ${response.message}`);
                                }
                            })
                            .catch((err) => {
                                console.error('SupponetUserSearch.js :get err:' + err.message);
                            });
                    }
                })
                .catch((err) => {
                    console.error('SupponetUserSearch.js :post err:' + err.message);
                });
        }
    }

    function handleCategoryChange(categoryId){
        if(categoryId !== ''){
            setSelectCategory(categoryId);
            const shubetsu = supponetData.shubetsu.filter((d) => d.categoryId === categoryId);
            setShubetsuList(shubetsu);
            setSelectShubetsu('');
            setDisplayShubetsu('');
            const selectCategory = categoryList.filter((d) => d.categoryId === categoryId);
            setDisplayCategory(selectCategory[0].categoryName);
        }
        else{
            setSelectCategory('');
            setDisplayCategory('');
            setSelectShubetsu('');
            setDisplayShubetsu('');
            setShubetsuList([]);
        }
    }

    function handleShubetsuChange(shubetsuId){
        if(shubetsuId !== ''){
            const selectShubetsu = shubetsuList.filter((d) => d.shubetsuId === shubetsuId);
            if(selectShubetsu.length !== 0) setDisplayShubetsu(selectShubetsu[0].shubetsuName);
            setSelectShubetsu(shubetsuId);
        }
        else {
            setDisplayShubetsu('');
            setSelectShubetsu('');
        }
    }

    function handleCreationDataChange(date){
        const dateArray = date.split('-');
        if(dateArray[0].length >= 5) {
            dateArray[0] = '9999';
            date = dateArray.join('-');
        }
        setCreationDate(date);
    }

    function handleReportDateChange(date){
        const dateArray = date.split('-');
        if(dateArray[0].length >= 5) {
            dateArray[0] = '9999';
            date = dateArray.join('-');
        }
        setReportDate(date);
    }

    useEffect(() => {
        if(categoryList.length === 0) getCategoryData();
    },[]);

    return (
        <React.Fragment>
            <Typography className={classes.title} variant="h6" component="p">
                絞り込み条件設定
            </Typography>
            <Paper elevation={2} variant="outlined" className={classes.paper}>
                <FormGroup className={classes.selectKubunArea} row>
                    <Typography variant="body1" className={classes.inputKeyword}>
                            レコード番号：
                    </Typography>
                    <FormControl className={classes.formControll}>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            className={classes.conditionLeft}
                            margin="normal"
                            value={recordId}
                            onChange={(event) => setRecordId(event.target.value)}
                        />
                    </FormControl>
                    <Typography variant="body1" className={classes.inputKeyword}>
                            メモ：
                    </Typography>
                    <FormControl className={classes.memo}>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            className={classes.conditionRight}
                            margin="normal"
                            value={memo}
                            onChange={(event) => setMemo(event.target.value)}
                        />
                    </FormControl>
                </FormGroup>
                <FormGroup className={classes.selectKubunArea} row>
                    <Typography variant="body1" className={classes.inputKeyword}>
                            受付日：
                    </Typography>
                    <FormControl className={classes.dateSelect}>
                        <TextField
                            id="outlined-basic"
                            type="date"
                            variant="outlined"
                            className={classes.conditionLeft}
                            margin="normal"
                            value={creationDate}
                            onChange={(event) => handleCreationDataChange(event.target.value)}
                        />
                    </FormControl>
                    <Typography variant="body1" className={classes.inputKeyword}>
                            住所：
                    </Typography>
                    <FormControl className={classes.memo}>
                        <TextField
                            id="outlined-basic"
                            variant="outlined"
                            className={classes.conditionRight}
                            margin="normal"
                            value={address}
                            onChange={(event) => setAddress(event.target.value)}
                        />
                    </FormControl>
                </FormGroup>
                <FormGroup className={classes.selectKubunArea} row>
                    <Typography variant="body1" className={classes.inputKeyword}>
                            確認日：
                    </Typography>
                    <FormControl className={classes.dateSelect}>
                        <TextField
                            id="outlined-basic"
                            type="date"
                            variant="outlined"
                            className={classes.conditionLeft}
                            margin="normal"
                            value={reportDate}
                            onChange={(event) => handleReportDateChange(event.target.value)}
                        />
                    </FormControl>
                    <Typography variant="body1" className={classes.inputKeyword}>
                            終了フラグ：
                    </Typography>
                    <FormControl className={classes.formControll}>
                        <Select
                                id="multiple-checkbox-johoKubun"
                                value={endFlg}
                                onChange={(event) => setEndFlg(event.target.value)}
                                variant="outlined"
                                className={classes.endFlg}
                            >
                            <MenuItem key={0} value={''} className={classes.deletionFlgList}>{'選択なし'}</MenuItem>
                            {publishFlg.map((rec, i) => (
                                <MenuItem key={i+1} value={rec} className={classes.deletionFlgList}>{`${rec}`}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </FormGroup>
                <FormGroup className={classes.selectKubunArea} row>
                    <Typography variant="body1" className={classes.inputKeyword}>
                        カテゴリ名：
                    </Typography>
                        <React.Fragment>
                        <FormControl className={classes.categorySelect}>
                            {/* */}
                            <Select
                                id="multiple-checkbox-johoKubun"
                                value={displayCategory}
                                className={classes.conditionLeft}
                                variant="outlined"
                            >
                                <MenuItem key={0} value={''} className={classes.deletionFlgList} onClick={() => handleCategoryChange('')}>{'選択なし'}</MenuItem>
                                {categoryList.map((rec, i) => (
                                    <MenuItem key={i+1} value={rec.categoryName} onClick={() => handleCategoryChange(rec.categoryId)} className={classes.deletionFlgList}>
                                        {`${rec.categoryName}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </React.Fragment>
                </FormGroup>
                <FormGroup className={classes.selectKubunArea} row>
                    <Typography variant="body1" className={classes.inputKeyword}>
                        報告種別名：
                    </Typography>
                        <React.Fragment>
                        <FormControl className={classes.shubetsuSelect}>
                            {/* */}
                            <Select
                                id="multiple-checkbox-johoKubun"
                                value={displayShubetsu}
                                className={classes.conditionLeft}
                                variant="outlined"
                            >
                                <MenuItem key={0} value={''} className={classes.deletionFlgList} onClick={() => handleShubetsuChange('')} >{'選択なし'}</MenuItem>
                                {shubetsuList.map((rec, i) => (
                                    <MenuItem key={i+1} value={rec.shubetsuName} onClick={() => handleShubetsuChange(rec.shubetsuId)} className={classes.deletionFlgList}>
                                        {`${rec.shubetsuName}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </React.Fragment>
                    <SearchButton
                        recordId={recordId}
                        memo={memo}
                        creationDate={creationDate}
                        address={address}
                        reportDate={reportDate}
                        endFlg={endFlg}
                        categoryId={selectCategory}
                        shubetsuId={selectShubetsu}
                        setData={setData}
                        setAllUpdate={setAllUpdate}
                        setIsLoading={setIsLoading}
                    />
                    <ResetButton
                        setRecordId={setRecordId}
                        setMemo={setMemo}
                        setCreationDate={setCreationDate}
                        setAddress={setAddress}
                        setReportDate={setReportDate}
                        setEndFlg={setEndFlg}
                        setShubetsuList={setShubetsuList}
                        setSelectCategory={setSelectCategory}
                        setSelectShubetsu={setSelectShubetsu}
                        setDisplayCategory={setDisplayCategory}
                        setDisplayShubetsu={setDisplayShubetsu}
                        setData={setData}
                    />
                </FormGroup>
            </Paper>
        </React.Fragment>
    );
});

SettingUserSearch.propTypes = {
    classes: PropTypes.object.isRequired,
    setData: PropTypes.func.isRequired,
    cookies: PropTypes.object.isRequired,
};


export default withStyles(styles)(SettingUserSearch);